<style>
  .container-gauge{
    height: 300px;
  }
</style>
<template>
<div id="device-stadistics-view">
  <div class="vx-row">
    <div class="vx-col w-full">
      <vs-button :to="`/env/detail/${uuid}`" class="w-full my-2 sm:w-auto" color="primary" type="filled">{{$t('Labels.Back')}}</vs-button>
    </div>
    <div class="vx-col w-full mb-base">
    <vs-tabs>
      <vs-tab :label="$t('Labels.State')" icon-pack="feather" icon="icon-list" @click="getResponse()">
        <vx-card
            title="Últimas Lecturas">
                <div style="width: 100%">
                  <a v-if="urlDownload.length > 0" class="btn-primary float-left" :href="urlDownload" download="LogEstado.csv"><feather-icon icon="DownloadCloudIcon" /></a>
                  <select class="vs-vs-inputx vs-input--input mb-3" v-model="log_limit" style="float: right; width: 90px;" @change="getResponse()">
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              <vs-table v-if="response" ref="table" :data="response">
              <template slot-scope="{data}">
                <tbody>
                  <tr class="tr-values vs-table--tr tr-table-state-null selected" :key="indextr" v-for="(item, indextr) in data" >
                     <listItem
                      :value="item.created_at"
                      :description="$t('Labels.Date')"
                      img="fecha"
                    ></listItem>
                    <listItem
                      :value="item.created_at"
                      :description="$t('Labels.LastUpdated')"
                      img="clock"
                      :relativeTime="true"
                    ></listItem>
                    <listItem
                      :value="parseFloat(item.temperature).toFixed(2)"
                      :description="$t('Labels.Temperature')"
                      img="temperature"
                      unit="°C"
                    ></listItem>
                    <listItem
                      :value="parseFloat(item.humidity).toFixed(2)"
                      :description="$t('Labels.Humidity')"
                      img="humedad"
                      unit="%"
                    ></listItem>
                  </tr>
                </tbody>
              </template>
            </vs-table>

        </vx-card>
      </vs-tab>
      <vs-tab :label="$t('Labels.InstantValues')" icon-pack="feather" icon="icon-activity" @click="getInfoGauges()">
        <vs-switch v-model="activeRefresh">
          <span slot="on">{{$t('Labels.Refresh')}}</span>
          <span slot="off">No {{$t('Labels.Refresh')}}</span>
        </vs-switch>
        <div class=" mt-12" v-if="showGauges">
          <div class="w-1/3 p-4 inline-block">
            <vx-card class="container-gauge">
              <gauge
                :min="limits.temperature.min"
                :max="limits.temperature.max"
                :alertMin="gauges.min_temp"
                :alertMax="gauges.max_temp"
                :title="$t('Labels.Temperature')"
                :value="gauges.temperature || 0"
                unit="°C"
              />
            </vx-card>
          </div>
          <div class="w-1/3  p-4 inline-block">
            <vx-card class="container-gauge">
              <gauge
                :min="limits.humidity.min"
                :max="limits.humidity.max"
                :alertMin="gauges.min_hum"
                :alertMax="gauges.max_hum"
                :title="$t('Labels.Humidity')"
                :value="gauges.humidity || 0"
                unit="%"
              />
            </vx-card>
          </div>
        </div>
      </vs-tab>
      <vs-tab :label="$t('Labels.Graphics')" icon-pack="feather" icon="icon-activity" @click="getCharts()">
        <div>{{$t('Labels.Today')}}</div>
        <div class="flex" v-if="showAvg24">
          <div class="flex-1 p-4">
            <statistics
              img="temperature"
              :value="parseFloat(avg24.avg_tem).toFixed(2)"
              :min="parseFloat(avg24.min_temp).toFixed(2)"
              :max="parseFloat(avg24.max_temp).toFixed(2)"
              unit="°C"
              :title="$t('Labels.Temperature')"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              img="humedad"
              :value="parseFloat(avg24.avg_hum).toFixed(2)"
              :min="parseFloat(avg24.min_hum).toFixed(2)"
              :max="parseFloat(avg24.max_hum).toFixed(2)"
              unit="%"
              :title="$t('Labels.Humidity')"
            />
          </div>
        </div>
        <div>{{$t('Labels.Last24Hours')}}</div>
        <div class="flex" v-if="showToday">
           <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticHumidity',1)">
              <apexchart v-if="humdityToday.loaded" type="line" height="350" :options="humdityToday.options" :series="humdityToday.data"></apexchart>
            </vx-card>
           </div>
           <div class="flex-1 p-3">
            <vx-card   :title="$tc('Labels.StatisticTemperature',1)">
              <apexchart v-if="tempToday.loaded" type="line" height="350" :options="tempToday.options" :series="tempToday.data"></apexchart>
            </vx-card>
           </div>
        </div>
        <div>{{$t('Labels.LastWeek')}}</div>
        <div class="flex" v-if="showWeek">
           <div class="flex-1 p-3">
            <vx-card :title="$tc('Labels.StatisticHumidity',2)">
              <apexchart v-if="humdityWeek.loaded" type="line" height="350" :options="humdityWeek.options" :series="humdityWeek.data"></apexchart>
            </vx-card>
           </div>
           <div class="flex-1 p-3">
            <vx-card   :title="$tc('Labels.StatisticTemperature',2)">
              <apexchart v-if="tempWeek.loaded" type="line" height="350" :options="tempWeek.options" :series="tempWeek.data"></apexchart>
            </vx-card>
           </div>
        </div>
      </vs-tab>
    </vs-tabs>
    </div>

  </div>

</div>

</template>

<script>
import apexchart from 'vue-apexcharts'
import { request } from '@/request.js'
import listItem from '@/components/listItem/listItem.vue'
import statistics from '@/components/statistics/statistics.vue'
import gauge from '@/components/gauge/gauge.vue'
import { empty } from '@/helpers.js'

export default {
  components: {
    apexchart,
    listItem,
    statistics,
    gauge
  },
  data () {
    return {
      response: [],
      humidity: {
        data: [{ data: [], name: 'Humedad' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} %`
              }
            }
          }
        }
      },
      temp: {
        data: [{ data: [], name: 'Temperatura' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} °C`
              }
            }
          }
        }
      },
      humdityWeek: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      tempWeek: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      tempToday: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      humdityToday: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      log_limit: '5',
      uuid: this.$route.params.uuid,
      urlDownload: '',
      avg24: {},
      gauges: [],
      limits: [],
      showGauges: false,
      showAvg24: false,
      showWeek: false,
      showToday: false,
      activeRefresh: false,
      doRefresh: {}
    }
  },
  methods: {
    async getResponse () {
      this.showGauges = false
      this.showAvg24 = false
      this.showWeek = false
      this.showToday = false
      this.$vs.loading()
      const params = {
        url: `modelo/temHum/${this.uuid}/log`,
        method: 'GET',
        params: {
          limit: this.log_limit
        }
      }
      await request(params).then(response => {
        this.response = response.data.data
        this.$vs.loading.close()
        this.createCsv()
      })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    getCharts () {
      this.showGauges = false
      this.getDayStatictics()
      this.getWeekStatistics()
      this.getTodayStatistics()
    },

    async getDayStatictics () {
      this.$vs.loading()
      const params = {
        url: `modelo/temHum/${this.uuid}/stadistics`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.avg24 = response.data.data[0]
        if (response.data.data.length > 0) {
          this.humidity.data[0].data.push(parseFloat(response.data.data[0].min_hum).toFixed(2))
          this.humidity.data[0].data.push(parseFloat(response.data.data[0].avg_hum).toFixed(2))
          this.humidity.data[0].data.push(parseFloat(response.data.data[0].max_hum).toFixed(2))

          this.temp.data[0].data.push(parseFloat(response.data.data[0].min_temp).toFixed(2))
          this.temp.data[0].data.push(parseFloat(response.data.data[0].avg_tem).toFixed(2))
          this.temp.data[0].data.push(parseFloat(response.data.data[0].max_temp).toFixed(2))
        }
        this.humidity.loaded = true
        this.temp.loaded = true
        this.showAvg24 = true
      })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    async getWeekStatistics () {
      this.$vs.loading()
      const params = {
        url: `modelo/temHum/${this.uuid}/week`,
        method: 'GET'
      }
      await request(params).then(response => {
        const api = this

        this.humdityWeek.labels = []
        this.humdityWeek.dataAvg = []
        this.humdityWeek.dataMin = []
        this.humdityWeek.dataMax = []

        this.tempWeek.labels = []
        this.tempWeek.dataAvg = []
        this.tempWeek.dataMin = []
        this.tempWeek.dataMax = []

        response.data.data.forEach(function (item) {
          api.tempWeek.labels.push(item.day.split(' ')[0])
          api.tempWeek.dataAvg.push(parseFloat(item.avg_temp).toFixed(2))
          api.tempWeek.dataMin.push(parseFloat(item.min_temp).toFixed(2))
          api.tempWeek.dataMax.push(parseFloat(item.max_temp).toFixed(2))
          api.humdityWeek.labels.push(item.day.split(' ')[0])
          api.humdityWeek.dataAvg.push(parseFloat(item.avg_hum).toFixed(2))
          api.humdityWeek.dataMin.push(parseFloat(item.min_hum).toFixed(2))
          api.humdityWeek.dataMax.push(parseFloat(item.max_hum).toFixed(2))
        })

        this.humdityWeek.data = [
          {
            name: 'Mínimo',
            data: this.humdityWeek.dataMin
          },
          {
            name: 'Promedio',
            data: this.humdityWeek.dataAvg
          },
          {
            name: 'Máximo',
            data: this.humdityWeek.dataMax
          }
        ]
        this.tempWeek.data = [
          {
            name: 'Mínimo',
            data: this.tempWeek.dataMin
          },
          {
            name: 'Promedio',
            data: this.tempWeek.dataAvg
          },
          {
            name: 'Máximo',
            data: this.tempWeek.dataMax
          }
        ]
        this.humdityWeek.options = this.getOptions()
        this.humdityWeek.options.xaxis.categories = this.humdityWeek.labels
        this.humdityWeek.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}%`
            }
          }
        }
        this.tempWeek.options = this.getOptions()
        this.tempWeek.options.xaxis.categories = this.tempWeek.labels
        this.tempWeek.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}°C`
            }
          }
        }
        this.tempWeek.loaded = true
        this.humdityWeek.loaded = true
        this.$vs.loading.close()
        this.showWeek = true
      })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    getOptions () {
      return {
        colors: ['#1fbee5', '#626262', '#ff0000'],
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 3,
          curve: 'smooth',
          dashArray: 0
        },
        title: {
          text: '',
          align: 'left'
        },
        xaxis: {
          categories: []
        },
        grid: {
          borderColor: '#f1f1f1'
        },
        tooltip: {
          y: {
            formatter (val) {
              return `${val}`
            }
          }
        }
      }
    },
    async getTodayStatistics () {
      this.$vs.loading()
      const params = {
        url: `modelo/temHum/${this.uuid}/today`,
        method: 'GET'
      }
      await request(params).then(response => {
        const api = this
        this.humdityToday.labels = []
        this.humdityToday.dataAvg = []
        this.humdityToday.dataMin = []
        this.humdityToday.dataMax = []

        this.tempToday.labels = []
        this.tempToday.dataAvg = []
        this.tempToday.dataMin = []
        this.tempToday.dataMax = []

        response.data.data.forEach(function (item) {
          api.tempToday.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.tempToday.dataAvg.push(parseFloat(item.avg_temp).toFixed(2))
          api.tempToday.dataMin.push(parseFloat(item.min_temp).toFixed(2))
          api.tempToday.dataMax.push(parseFloat(item.max_temp).toFixed(2))
          api.humdityToday.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.humdityToday.dataAvg.push(parseFloat(item.avg_hum).toFixed(2))
          api.humdityToday.dataMin.push(parseFloat(item.min_hum).toFixed(2))
          api.humdityToday.dataMax.push(parseFloat(item.max_hum).toFixed(2))
        })

        this.humdityToday.data = [
          {
            name: 'Mínimo',
            data: this.humdityToday.dataMin
          },
          {
            name: 'Promedio',
            data: this.humdityToday.dataAvg
          },
          {
            name: 'Máximo',
            data: this.humdityToday.dataMax
          }
        ]
        this.tempToday.data = [
          {
            name: 'Mínimo',
            data: this.tempToday.dataMin
          },
          {
            name: 'Promedio',
            data: this.tempToday.dataAvg
          },
          {
            name: 'Máximo',
            data: this.tempToday.dataMax
          }
        ]
        this.humdityToday.options = this.getOptions()
        this.humdityToday.options.xaxis.categories = this.humdityToday.labels
        this.humdityToday.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}%`
            }
          }
        }

        this.tempToday.options = this.getOptions()
        this.tempToday.options.xaxis.categories = this.tempToday.labels
        this.tempToday.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}°C`
            }
          }
        }

        this.tempToday.loaded = true
        this.humdityToday.loaded = true
        this.$vs.loading.close()
        this.showToday = true
      })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    createCsv () {
      const csv = []
      const headers = []
      headers.push(this.$t('Labels.Date'))
      headers.push(this.$t('Labels.LastSeen'))
      headers.push(this.$t('Labels.Temperature'))
      headers.push(this.$t('Labels.Humidity'))
      csv.push(headers.join(','))
      this.response.map(item => {
        const row = []
        row.push(item.created_at)
        row.push(this.relativeTimeConvert(item.created_at))
        row.push(`${item.temperature}°C`)
        row.push(`${item.humidity}%`)
        csv.push(row.join(','))
        return item
      })
      const file = csv.join('\n')
      const csvFile = new Blob([file], { type: 'text/csv' })
      this.urlDownload = window.URL.createObjectURL(csvFile)
    },
    relativeTimeConvert (date) {
      date.replace(' ', 'T')
      return this.$dayjs().to(this.$dayjs(date))
    },
    async getInfoGauges () {
      this.showAvg24 = false
      this.showWeek = false
      this.showToday = false
      this.$vs.loading()
      const params = {
        url: `modelo/temHum/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.gauges = response.data.data
        this.limits = response.data.limits
        this.showGauges = true
      }).finally(() => {
        this.$vs.loading.close()
      })
    }
  },
  created () {
    this.getResponse()
  },
  watch: {
    activeRefresh (val) {
      if (val) {
        const app = this
        let miliseconds = 0
        const units = {
          seconds: 1000,
          minutes: 60000,
          hours: 3600000
        }
        if (!empty(this.gauges.time) && !empty(this.gauges.time_unity)) { miliseconds = parseInt(this.gauges.time) * parseInt(units[this.gauges.time_unity]) } else { miliseconds = 11000 }

        this.doRefresh = setInterval(function () {
          app.getInfoGauges()
        }, miliseconds)
      } else {
        clearInterval(this.doRefresh)
      }
    }
  }

}
</script>
